<h1>
    <span>Update Plan</span>
    <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
<div class="col-sm-12">
<form [formGroup]="planLeadForm" (submit)="updatePlan()">
    <div class="form-group">
        <div class="row">
            <div class="col-sm-4">
                <label class="form-label">Name </label>
                <input type="text" formControlName="name" class="form-control" readonly />
            </div>
            <div class="col-sm-4">
                <label class="form-label">Mobile </label>
                <input type="text" formControlName="mobile" class="form-control" readonly />
            </div>
            <div class="col-sm-4">
                <label class="form-label">Circle </label>
                <input type="text" formControlName="circle_name" class="form-control" readonly />
            </div>
        </div><br>
        <div class="row">
            <div class="col-sm-4">
                <label class="form-label">City </label>
                <input type="text" formControlName="city" class="form-control" readonly />
            </div>
            <div class="col-sm-4">
                <label class="form-label">Lead Source </label>
                <input type="text" formControlName="lead_source" class="form-control" readonly />
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label class="form-label">Package Type</label>
                    <mat-select placeholder="Package Type" formControlName="package_type_id">
                        <mat-option [value]="ptype.id" *ngFor="let ptype of package_type">{{ptype.plan_name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </div><br>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="form-label">Lead Status</label>
                    <mat-select placeholder="Lead Status" formControlName="lead_status_id">
                        <input class="mySearchInput" #lead_status_Search focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                            id="lead_status_Search">
                        <mat-option [value]="lead_status.id" *ngFor="let lead_status of leadStatus">{{lead_status.name}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="form-label">Description</label>
                    <textarea class="form-control" formControlName="description"></textarea>
                </div>
            </div>
        </div>
    </div><br>
    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
            class="fa fa-spin fa-spinner"></i>
        <span>Update Plan</span>
    </button>
</form>
</div>
</div>